var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.5 22q-.825 0-1.412-.587A1.93 1.93 0 0 1 9.5 20h4q0 .824-.588 1.413A1.93 1.93 0 0 1 11.5 22m-7-3a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3.5 18q0-.424.288-.712A.97.97 0 0 1 4.5 17h1v-7q0-2.074 1.25-3.687T10 4.2v-.7q0-.625.438-1.062A1.45 1.45 0 0 1 11.5 2q.624 0 1.063.438Q13 2.874 13 3.5v.325a4.606 4.606 0 0 0-.5 2.3q-.25-.05-.488-.088A3 3 0 0 0 11.5 6Q9.85 6 8.675 7.175T7.5 10v7h8v-6.425a5 5 0 0 0 2 .425v6h1q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 18.5 19zm13-10a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 14.5 6q0-1.25.875-2.125A2.9 2.9 0 0 1 17.5 3q1.25 0 2.125.875T20.5 6t-.875 2.125A2.9 2.9 0 0 1 17.5 9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationUnread);
export default __webpack_public_path__ + "static/media/Notification_unread.95e8a0982df316fde4ddcb12cd697fe6.svg";
export { ForwardRef as ReactComponent };